export default __webpack_public_path__ + "static/media/818.2946da8c.gif";